import {z as r} from 'zod';

export const aspectsSchema = r.object({
    ids: r.array(r.number()),
    title: r.string(),
});

export type AspectsType = r.infer<typeof aspectsSchema>;
